module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 19
// module chunks = 0 1